import { List, Spin, Typography } from 'antd';
import { customizeEmpty } from 'components/common';
import React from 'react';
import VirtualList from 'rc-virtual-list';
import { InView } from 'react-intersection-observer';
import OmniChannelChatHistoriesSessionItemSkeleton from './OmniChannelChatHistoriesSessionItemSkeleton';
import { formatNumber } from 'utils';
import { useOmniHistoriesLeadManageContext } from 'contexts';
import { ChatHistoryGroup, ChatSessionDto } from 'types';
import { omniChatMessages } from 'messages';
import OmniChannelLeadChatHistoriesSessionItem from './OmniChannelLeadChatHistoriesSessionItem';

type Props = {};

const renderSkeletonItems = () => {
  return Array.from({ length: 5 }).map((_, index) => (
    <div key={`skeleton-${index}`} className='w-full border-b'>
      <OmniChannelChatHistoriesSessionItemSkeleton />
    </div>
  ));
};

const renderChatHistoryGroup = (group: ChatHistoryGroup, onClick: (item: ChatSessionDto) => void) => {
  return (
    <div key={group.date}>
      <div className='flex flex-col'>
        {group.sessions.map((session) => (
          <div className='h-auto w-full p-0' key={session.chatSessionId}>
            <OmniChannelLeadChatHistoriesSessionItem onClick={() => onClick(session)} item={session} />
          </div>
        ))}
      </div>
    </div>
  );
};

const OmniChannelLeadChatHistoriesSessionList: React.FC<Props> = ({}) => {
  const {
    chatSessionHistories,
    countHistories,
    handleLoadMoreHistories,
    hasMoreHistories,
    setChatHistory,
    validateHistory,
    isLoadingHistories,
    isFetchingHistories,
  } = useOmniHistoriesLeadManageContext();

  const handleInViewChange = (isVisible: boolean) => {
    if (isVisible) {
      handleLoadMoreHistories();
    }
  };

  const handleSelectChatSession = (session: ChatSessionDto) => {
    setChatHistory(session);
  };

  return (
    <div className='flex h-full max-h-[calc(100vh-180px)] w-full flex-col'>
      <div className='flex h-16 shrink-0 items-center border-b px-5'>
        <Typography.Text ellipsis className='max-w-full text-lg font-semibold'>
          {isLoadingHistories || validateHistory ? 0 : formatNumber(countHistories ?? 0)} kết quả
        </Typography.Text>
      </div>
      {isLoadingHistories ? (
        <div className='flex items-center justify-center pt-20'>
          <Spin spinning />
        </div>
      ) : (
        <>
          {validateHistory || !chatSessionHistories || chatSessionHistories.length === 0 ? (
            <div className='flex h-full w-full flex-col'>
              <div className='flex items-center justify-center pt-[160px]'>
                {customizeEmpty({ description: omniChatMessages.emptyDescription })}
              </div>
            </div>
          ) : (
            <List className='max-h-full w-full flex-1 overflow-auto pb-6'>
              <VirtualList itemKey='title' data={chatSessionHistories} fullHeight>
                {(group: ChatHistoryGroup) => renderChatHistoryGroup(group, handleSelectChatSession)}
              </VirtualList>
              {isFetchingHistories && renderSkeletonItems()}
              {hasMoreHistories && <InView onChange={handleInViewChange}>{}</InView>}
            </List>
          )}
        </>
      )}
    </div>
  );
};
export default OmniChannelLeadChatHistoriesSessionList;
